import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { ProfileComponent } from './profile.component';

export const ProfileRoutes: Routes = [
    {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthService],
    },
];
